
import { Component, mixins } from 'nuxt-property-decorator';
import { AccordionBlockModel } from 'fourwaves-shared';
import { RawHtml } from 'fourwaves-shared/components';
import ContentBlockMixin from '../../ContentBlockMixin';
import AccordionBlockListItem from './AccordionBlockListItem.vue';

@Component({
  components: {
    RawHtml,
    AccordionBlockListItem,
  },
})
export default class AccordionBlock extends mixins(ContentBlockMixin<AccordionBlockModel>) {}
